import React from 'react'
import styled, { useTheme } from 'styled-components'

import { TEXT_STYLES } from 'TEXT_STYLES'
import { PLAN_DETAILS } from 'constants/plan_details'
import { highlightColor } from './PlanDetails'
import { Text } from '@junglescout/edna'
import { useTranslation } from 'react-i18next'

const Wrapper = styled.div`
  min-width: 222px;
  display: flex;
  flex-direction: column-reverse;
  flex: auto;
  align-items: center;
  padding: 12px 0;
`
const Details = styled.div`
  width: 100%;
  div:nth-child(even) {
    background-color: ${props => props.theme.colors.grey025};
  }
`
const Row = styled.div`
  ${TEXT_STYLES.BodyBlack}
  font-weight: 500 !important;
  height: 26px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  gap: 4px;
`
const NewTag = styled(Text).attrs({
  color: 'white',
  variant: 'bodyXs',
  fontWeight: 600
})`
  background-color: ${highlightColor};
  border-radius: 10px;
  padding: 1px 4px;
  width: 32px;
  height: 18px;
  box-sizing: initial;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const PlanFeatures = () => {
  const { colors } = useTheme()
  const { t } = useTranslation(['generic'])

  return (
    <Wrapper>
      <Details>
        {Object.keys(PLAN_DETAILS).map((feature, index) => {
          const isHighlighted = feature.match(/Competitive Intelligence:/)

          if (isHighlighted) {
            return (
              <Row key={index}>
                <NewTag> {t('generic:NewTag', 'NEW')}</NewTag>
                <Text color={highlightColor} fontWeight={600}>
                  {feature}
                </Text>
              </Row>
            )
          }
          return (
            <Row key={index}>
              <Text color={colors.grey900}>{feature}</Text>
            </Row>
          )
        })}
      </Details>
    </Wrapper>
  )
}
